import {post} from 'jquery';
import {globalActions} from '../store/global-actions';
import {store} from '../store/global-store';

function initFavoriteSwitchComponent(app) {
    app.component('favorite-switch', {
        template: '#favorite-switch',
        props: {
            toggleUrl: {
                required: true,
                type: String,
            },
            favorite: {
                type: Boolean,
                required: true,
            },
            hasLabel: {
                type: Boolean,
                default: false,
            },
            listingId: {
                type: Number,
                required: true,
            },
            isAuthenticated: {
                type: Boolean,
                default: false,
            },
            isMobile: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                isClickable: true,
            };
        },
        computed: {
            isFavorite() {
                return store.state.advert.favoriteListingState[this.listingId] != undefined ?
                    store.state.advert.favoriteListingState[this.listingId] :
                    this.favorite;
            },
        },
        methods: {
            toggle(forceFavorite = false) {
                if (this.isClickable) {
                    this.isClickable = false;
                    post(this.toggleUrl, {forceFavorite})
                        .done((result) => this.setFavoriteState(result))
                        .fail((error) => {
                            this.saveFavoriteListingId();
                            globalActions.handleAjaxErrors(error);
                        })
                        .always(() => this.isClickable = true);
                }
            },
            saveFavoriteListingId() {
                localStorage.setItem('favorite', this.listingId);
            },
            setFavoriteState(state) {
                store.commit('setFavoriteListingState', {listingId: this.listingId, state: state});
            },
        },
        watch: {
            isFavorite(value) {
                this.$emit('update:favorite', value);
            },
        },
        mounted() {
            const favoriteListingId = localStorage.getItem('favorite');
            if (favoriteListingId == this.listingId && this.isAuthenticated) {
                this.toggle(true);
                localStorage.removeItem('favorite');
            }
        },
    });
}

export default initFavoriteSwitchComponent;
